import { render } from "./ChatBody.vue?vue&type=template&id=15d3e96c&scoped=true"
import script from "./ChatBody.vue?vue&type=script&lang=js"
export * from "./ChatBody.vue?vue&type=script&lang=js"

import "./ChatBody.vue?vue&type=style&index=0&id=15d3e96c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d3e96c"]])

export default __exports__